module.exports = __webpack_public_path__ + "static/img/img.35dbe7d0.png";